import { createReducer, createFeature, on } from '@ngrx/store';
import { Destination } from '../../../objects/destination';
import { DestinationActions } from '../actions';

export interface State {
  destination: Destination | null;
  destinations: Destination[] | null;

  destinationLoading: boolean;
  destinationsLoading: boolean;

  error: Error | null;
}

export const initialState: State = {
  destination: null,
  destinations: null,

  destinationLoading: false,
  destinationsLoading: false,

  error: null,
};

export const destinationFeature = createFeature({
  name: 'destination',
  reducer: createReducer(
    initialState,
    on(DestinationActions.setDestination, (state, { destination }) => ({ ...state, destination })),

    on(DestinationActions.loadDestination, state => ({ ...state, destinationLoading: true, error: null, destination: null })),
    on(DestinationActions.loadDestinationSuccess,
      (state, { destination }) => ({ ...state, destination, destinationLoading: false, error: null })),
    on(DestinationActions.loadDestinationFailure, (state, { error }) => ({ ...state, destination: null, destinationLoading: false, error })),

    on(DestinationActions.loadDestinations, state => ({ ...state, destinationsLoading: true, error: null })),
    on(DestinationActions.loadDestinationsSuccess,
      (state, { destinations }) => ({ ...state, destinations, destinationsLoading: false, error: null })),
    on(DestinationActions.loadDestinationsFailure,
      (state, { error }) => ({ ...state, destinations: null, destinationsLoading: false, error })),
  ),
});

export const {
  name: destinationFeatureKey,
  reducer,
  selectDestinationState,
  selectDestination,
  selectDestinations,
  selectDestinationLoading,
  selectDestinationsLoading,
  selectError: selectDestinationError,
} = destinationFeature;
